import styled from '@emotion/styled'
import { Text } from '@hhgtech/hhg-components/components'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledAudioPlayerWrapper = styled.div`
  display: flex;
  min-height: 48px;
  height: 48px;
  background-color: ${theme.colors.primary50};
  border-radius: 4px;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 24px;
  user-select: none;
  gap: 16px;
  ${MediaQueries.mbDown} {
    background-color: #ffffff;
    border-radius: 0;
    padding: 0;
    flex-direction: column;
    min-height: initial;
    height: initial;
    gap: 4px;
    margin: 0;
  }
`

export const StyledAudioPlayerIcon = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
  /* margin-left: -2px; */
`

export const StyledAudioPlayerControlsWrapper = styled.div`
  &.hidden {
    display: none;
  }
`

export const StyledAudioPlayerMiddle = styled.div`
  flex: 1;
  ${MediaQueries.mbDown} {
    max-width: 85px;
    .mobile-navigation-label {
      width: 70px;
      text-align: center;
      font-weight: 500;
      font-size: 10px;
      line-height: 16px;
      color: ${theme?.colors.gray600};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      ${MediaQueries.mbDown} {
        max-width: 70px;
      }
    }
  }
`

export const StyledAudioPlayerProgress = styled.div`
  height: 4px;
  width: 100%;
  background-color: ${theme.colors.white};
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
`

export const StyledAudioPlayerProgressBar = styled.div`
  background-color: ${theme.colors.primaryBase};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
`

export const StyledAudioTrackProgress = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

export const StyledAudioTrackTime = styled(Text)`
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`
